import { Component, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer, SideNav, TopBar } from '../partials/layouts.js';
import { LogoutModal } from './logout.js';
import {postFile, postData, updateData} from './constants.js';
import complaint_violation from '../pdf/complaint_violation.pdf'
import architecture_change from '../pdf/architecture_change.pdf';
import new_construction from '../pdf/new_construction.pdf';
import tree_removal from '../pdf/tree_removal.pdf';
import estate_sale from '../pdf/estate_sale_acc.pdf';

import jsPDF from 'jspdf';

const moment = require('moment');

function ChangeRequestList(props) {
    const change_request_list = props.data.map((item)=>
      <tr key={item.id} id={item.id}>
          <td>{moment(item.application_date).format("l")}</td>
          <td>{item.change_state}</td>
          <td className={(item.status==='approved'?'text-success':(item.status==='declined'?'text-danger':'text-primary'))}>{item.status.toLocaleUpperCase()}</td>
          <td className="text-nowrap">{item.chairpersonACC}</td>
          <td className="text-nowrap">{item.approved_date?moment(item.approved_date).format("l"):""}</td>
          <td className="text-center"><Link id={item.id} className="font-weight-bold text-warning" to={'/edit-change-request/'+item.id}><i className="fas fa-pencil-alt"></i></Link></td>
          <td><Link id={item.id} className="font-weight-bold text-primary" to={'/change-request/'+item.id}>View</Link></td>
      </tr>
    );
    return(
        <>
        <div className="row">
            <div className="col-xs-12 col-md-12">

                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <h2 className="m-0 font-weight-bold text-white">ACC Requests</h2>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive change_request-table">
                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Request Type</th>
                                        <th>Status</th>
                                        <th>Chairperson</th>
                                        <th>Approved Date</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                      {change_request_list}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

class ChangeRequests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data      : [],
      isLoading : true,
    };
  }

  async getChangeRequests() {
    try {
      const response = await fetch('/api/change-requests');
      const json = await response.json();
      console.log(json);
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getChangeRequests();
  }

  render() {
    return (
      <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-md-12 col-lg-12 col-xs-12">
                          <ChangeRequestList data={this.state.data} />
                        </div>
                      </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
      </>
    );
  }
}

class ArchitectureChangeForm extends Component {
    constructor(props) {
      super(props);
      this.state = {
        id               :"",
        applicant_name   :"",
        applicant_address:"",
        email            :"",
        phone            :"",
        change_state     :"",
        start_date       :moment().format("YYYY-MM-DD"),
        roof_replacement :"",
        repainting       :"",
        repainting_color_ref :"",
        patio            :"",
        screen_enclosure :"",
        garage_door      :"",
        cart_room_door   :"",
        other_arch_changes :"",
        request_description:"",
        isLoading        :true,
        currentRow       : 1,
        LineItem1Type    : "",
        LineItem2Type    : "",
        LineItem3Type    : "",
        LineItem4Type    : "",
        LineItem5Type    : "",
        LineItem6Type    : "",
        changeTypes      :[
           { label:"-- select type  --", original:"" },
           { label:"Roof Replacement", original:"roof_replacement" },
           { label:"Repainting", original:"repainting" },
           { label:"Patio", original:"patio" },
           { label:"Screen Enclosure", original:"screen_enclosure" },
           { label:"Cart Room Door", original:"cart_room_door" },
           { label:"Garage Door", original:"garage_door" },
           { label:"Others", original:"other_arch_changes" }
          ],
        properties      : []
      };
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSelect = this.handleSelect.bind(this);
      this.handleFileChange = this.handleFileChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.AddLineItem = this.AddLineItem.bind(this);
      this.handleLineItem = this.handleLineItem.bind(this);
      this.disableSelect = this.disableSelect.bind(this);
    }

    AddLineItem(event) {
      if(this.state.changeTypes.length > -1 && eval(`this.state.LineItem${this.state.currentRow}Type`)){
        var previousEl = document.getElementById(`change_type${this.state.currentRow}`);
        if(previousEl) previousEl.disabled = true;
        var changeTypes = this.state.changeTypes;
        const index = changeTypes.findIndex(object => {
          return object.original === eval(`this.state.LineItem${this.state.currentRow}Type`);
        });
        if(index > -1 && this.state.currentRow < 8){
          changeTypes.splice(index, 1);
          this.setState({changeTypes: changeTypes});
          this.setState({currentRow: parseInt(this.state.currentRow+1)});
          console.log("currentRow", this.state.currentRow);
        }else if(this.props.accRequestData && this.state.id){
          this.setState({currentRow: parseInt(this.state.currentRow+1)});
        }
      }
    }

    handleLineItem(event){
      const target = event.target;
      const value  =  target.value;
      const index = this.state.changeTypes.findIndex(object => {
        return object.original === value;
      });
      const selectedRow = parseInt(target.attributes.row.value);
      this.setState({ currentRow: selectedRow});
      var key = `LineItem${selectedRow}Type`;
      if(index > -1){
        this.setState({ [key]: value });
      }else{
        this.setState({ [key]: "" });
      }
    }

    handleInputChange(event) {
      const target = event.target;
      const value =  target.value;
      const name = target.name;

      this.setState({
        [name]: value
      });
    }

    handleSelect(event) {
      const target = event.target;
      const value =  target.value;
      var property = {};
      if(value){
        property = this.state.properties.find(a=>{
          if(a.id === parseInt(value)){
            return a;
          }
        });
        if(property.id){
          console.log("property", property);
          this.setState({applicant_name: property.first_name, 
                          applicant_address: property.wo_street_address,
                          email: property.email, phone: property.phone})
        }
      }
    }

    handleFileChange(event){
      const key = event.target.name;
      let value = event.target.files[0].name;
      if(value.length>20){
        value = value.slice(0,15);
        value = value.concat('...');
      }
      this.setState({
        [key]: value
      })
    }

    handleSubmit(event) {
      event.preventDefault();
      const formEl = document.getElementById("architecture-form");
      formEl.disabled = true;
      var formData = new FormData();
      if(this.state.roof_replacement){
        var roof_replacement_file = document.getElementById("roof_replacement_file").files[0];
        if(roof_replacement_file) formData.append('roof_replacement_file_ref', roof_replacement_file);
      }
      if(this.state.repainting){
        var repainting_file = document.getElementById("repainting_file").files[0];
        if(repainting_file) formData.append('repainting_color_ref', repainting_file);
      }
      if(this.state.patio){
        var patio_file = document.getElementById("patio_file").files[0];
        if(patio_file) formData.append('patio_file_ref', patio_file);
      }
      if(this.state.cart_room_door){
        var cart_room_door_file = document.getElementById("cart_room_door_file").files[0];
        if(cart_room_door_file) formData.append('cart_room_door_file_ref', cart_room_door_file);
      }
      if(this.state.garage_door){
        var garage_door_file = document.getElementById("garage_door_file").files[0];
        if(garage_door_file) formData.append('garage_door_file_ref', garage_door_file);
      }
      if(this.state.screen_enclosure){
        var screen_enclosure_file = document.getElementById("screen_enclosure_file").files[0];
        if(screen_enclosure_file) formData.append('screen_enclosure_file_ref', screen_enclosure_file);
      }
      if(this.state.other_arch_changes){
        var other_arch_changes_file = document.getElementById("other_arch_changes_file_ref").files[0];
        if(other_arch_changes_file) formData.append('other_arch_file_ref', repainting_file);
      }

      var data = this.state;
      delete data.isLoading;
      formData.append('jsonData', JSON.stringify(data));

      postFile('/api/architecture-change', formData)
        .then((response) => {
          console.log(response);
          this.props.navigate('/change-requests');
      });
    }

    async disableSelect() {
      for(var i=1;i<=this.state.currentRow;i++){
        const El = await document.getElementById(`change_type${i}`);
        if(El) El.disabled = true;
      }
    }

    async getResidentProperties() {
      try {
        const response = await fetch('/api/resident-properties');
        const json = await response.json();
        this.setState({ properties: json });
      } catch (error) {
        console.log(error);
      } finally {
        if(this.state.properties.length===1){
          var property = this.state.properties[0];
          this.setState({applicant_name: property.first_name, 
                applicant_address: property.wo_street_address,
                email: property.email, phone: property.phone, isLoading: false})
        }else{
          this.setState({ isLoading: false });
        }
      }
    }

    componentDidMount() {
      if(this.props.accRequestData) {
        var changeRequest = this.props.accRequestData;
        changeRequest.start_date = moment(changeRequest.start_date).format("YYYY-MM-DD");
        this.setState(changeRequest);
        var c = changeRequest;
        var lineItems = [
          {"type":"roof_replacement", "value":c.roof_replacement},
          {"type":"repainting", "value":c.repainting},
          {"type":"patio", "value":c.patio},
          {"type":"screen_enclosure", "value":c.screen_enclosure},
          {"type":"garage_door", "value":c.garage_door},
          {"type":"cart_room_door", "value":c.cart_room_door},
          {"type":"other_arch_changes", "value":c.other_arch_changes}
        ];
        var count = 1;
        lineItems.map((l,i)=>{
          if(l.value){
            var key = `LineItem${count}Type`;
            this.setState({"currentRow": count, [key]:l.type})
            var changeTypes = this.state.changeTypes;
            const index = changeTypes.findIndex(object => {
              return object.original === l.type;
            });
            if(index > -1){
              changeTypes.splice(index, 1);
              this.setState({changeTypes: changeTypes});
            }
            count++;
            this.disableSelect();
          }
        });
      }
      this.getResidentProperties();
    }

    render() {
      const data = this.state;
      const ChangeTypeList = data.changeTypes.map((a,i)=>{
        return `<option>${a.original}</option>`
      }).join("");
      document.getElementById("dl-change-types").innerHTML = ChangeTypeList;

      const properties=this.state.properties.map(property=>
          <option key={property.id} value={property.id}>{property.wo_street_address}</option>
      );
      
      return(
        <div className="card shadow mb-2">
            <div className="card-header py-3">
                <h4 className="m-0 font-weight-bold text-white">Architecture Change Form</h4>
            </div>
            <div className="card-body">
            <div className='titles'>
                <p>Whispering oaks estates homeowners association, inc.<br/>35142 Whispering Oaks Boulevard, Ridge Manor FL 33523<br/>
                <b> ARCHITECTURAL CONTROL COMMITTEE (ACC)</b>
               
                </p>
                <h5>Request Approval for Home Improvement as Described Below</h5>
              </div>
                <form className="user acc-form" onSubmit={this.handleSubmit} autoComplete="off">
                  <fieldset id="architecture-form">
                      {this.state.properties.length>1 &&
                        <div className="row">
                          <div className="col-md-6 col-lg-4 col-xs-12">
                              <div className="form-group">
                                  <label>Property</label>
                                  <select name="property" className="form-control form-control-sm" onChange={this.handleSelect}>
                                  <option value=""> -- Select Property -- </option>
                                  {properties}
                                  </select>
                              </div>
                          </div>    
                        </div>
                      }
                      <div className="row">                     
                          <div className="col-md-6 col-lg-4 col-xs-12">
                              <div className="form-group">
                                  <label>Name of Owner</label>
                                  <input type="text" name="applicant_name" maxLength="100" className="form-control form-control-sm" value={data.applicant_name} onChange={this.handleInputChange} required />
                              </div>
                          </div>
                          <div className="col-md-6 col-lg-4 col-xs-12">
                              <div className="form-group">
                                  <label>Address</label>
                                  <textarea rows="1" type="text" name="applicant_address" maxLength="250" className="form-control form-control-sm" value={data.applicant_address} onChange={this.handleInputChange} required />
                              </div>
                          </div>
                          <div className="col-md-6 col-lg-4 col-xs-12">
                              <div className="form-group">
                                  <label>Contact Email</label>
                                  <input type="email" name="email" maxLength="100" className="form-control form-control-sm"  value={data.email} onChange={this.handleInputChange} required />
                              </div>
                          </div>
                          <div className="col-md-6 col-lg-4 col-xs-12">
                              <div className="form-group">
                                  <label>Contact Phone</label>
                                  <input type="text" name="phone" maxLength="20" className="form-control form-control-sm" value={data.phone} onChange={this.handleInputChange} />
                              </div>
                          </div>
                          <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="form-group">
                              <label>The anticipated start date is</label>
                              <input type="date" className="form-control form-control-sm" name="start_date" value={data.start_date} onChange={this.handleInputChange} required />
                            </div>
                          </div>
                      </div>
                      <div className="row" id="changeLineItem">
                        {data.currentRow >=1 &&
                          <>
                            <div className="col-md-4 col-lg-3 col-xs-12">
                                <div className="form-group">
                                    <label>Type of Change</label>
                                    <input id="change_type1" className="form-select" row={1} value={data.LineItem1Type} onChange={this.handleLineItem} list="dl-change-types" />
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xs-12">
                              {data.LineItem1Type &&
                                <div className="form-group">
                                  <label> Description </label>
                                  <input type="text" name={data.LineItem1Type} className="form-control" maxLength="100" value={eval(`data.${data.LineItem1Type}`)} onChange={this.handleInputChange} />
                                </div>
                              }
                            </div>
                            <div className="col-md-2 col-lg-3 col-xs-12">
                              {data.LineItem1Type &&
                                <div className="form-group">
                                  <label>Attachment</label>
                                    {data.fileName1?(
                                        <span className="ml-1 text-success">{data.fileName1}</span>
                                    ):(
                                      <>
                                        {(data.LineItem1Type==="repainting" && data.repainting_color_ref)?(
                                          <a href={data.repainting_color_ref} target="_blank" className="ml-2">View Previous File</a>
                                        ):(
                                          <>
                                            {(data.LineItem1Type==="other_arch_changes" && data.other_arch_file_ref)?(
                                              <a href={data.other_arch_file_ref} target="_blank" className="ml-2">View Previous File</a>
                                            ):(
                                              <>
                                              {eval(`data.${data.LineItem1Type}_file_ref`) &&
                                                <a href={eval(`data.${data.LineItem1Type}_file_ref`)} target="_blank" className="ml-2">View Previous File</a>
                                              }
                                              </>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}
                                  <div className="input-group input-group-sm">
                                      <div className="custom-file">
                                         <input type="file" name="fileName1" className="custom-file-input" id={`${data.LineItem1Type}_file`} aria-describedby="inputGroupFileAddon04" onChange={this.handleFileChange} />
                                         <label className="custom-file-label">Choose file</label>
                                      </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </>
                        }
                        {data.currentRow >=2 &&
                          <>
                            <div className="col-md-4 col-lg-3 col-xs-12">
                                <div className="form-group">
                                    <label>Type of Change</label>
                                    <input id="change_type2" className="form-select" row={2} value={data.LineItem2Type} onChange={this.handleLineItem} list="dl-change-types" />
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xs-12">
                              {data.LineItem2Type &&
                                <div className="form-group">
                                  <label> Description </label>
                                  <input type="text" name={data.LineItem2Type} className="form-control" maxLength="100" value={eval(`data.${data.LineItem2Type}`)} onChange={this.handleInputChange} />
                                </div>
                              }
                            </div>
                            <div className="col-md-2 col-lg-3 col-xs-12">
                              {data.LineItem2Type &&
                                <div className="form-group">
                                  <label>Attachment</label>
                                  {data.fileName2?(
                                    <>
                                      <span className="ml-1 text-success">{data.fileName2}</span>
                                    </>
                                  ):(
                                    <>
                                      {(data.LineItem2Type==="repainting" && data.repainting_color_ref)?(
                                        <a href={data.repainting_color_ref} target="_blank" className="ml-2">View Previous File</a>
                                      ):(
                                        <>
                                          {(data.LineItem2Type==="other_arch_changes" && data.other_arch_file_ref)?(
                                            <a href={data.other_arch_file_ref} target="_blank" className="ml-2">View Previous File</a>
                                          ):(
                                            <>
                                            {eval(`data.${data.LineItem2Type}_file_ref`) &&
                                              <a href={eval(`data.${data.LineItem2Type}_file_ref`)} target="_blank" className="ml-2">View Previous File</a>
                                            }
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                  <div className="input-group">
                                      <div className="custom-file">
                                         <input type="file" name="fileName2" className="custom-file-input" id={`${data.LineItem2Type}_file`} aria-describedby="inputGroupFileAddon04" onChange={this.handleFileChange} />
                                         <label className="custom-file-label">Choose file</label>
                                      </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </>
                        }
                        {data.currentRow >= 3 &&
                          <>
                            <div className="col-md-4 col-lg-3 col-xs-12">
                                <div className="form-group">
                                    <label>Type of Change</label>
                                    <input id="change_type3" className="form-select" row={3} value={data.LineItem3Type} onChange={this.handleLineItem} list="dl-change-types" />
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xs-12">
                              {data.LineItem3Type &&
                                <div className="form-group">
                                  <label> Description </label>
                                  <input type="text" name={data.LineItem3Type} className="form-control" maxLength="100" value={eval(`data.${data.LineItem3Type}`)} onChange={this.handleInputChange} />
                                </div>
                              }
                            </div>
                            <div className="col-md-2 col-lg-3 col-xs-12">
                              {data.LineItem3Type &&
                                <div className="form-group">
                                  <label>Attachment</label>
                                  {data.fileName3?(
                                    <>
                                      <span className="ml-1 text-success">{data.fileName3}</span>
                                    </>
                                  ):(
                                    <>
                                      {(data.LineItem3Type==="repainting" && data.repainting_color_ref)?(
                                        <a href={data.repainting_color_ref} target="_blank" className="ml-2">View Previous File</a>
                                      ):(
                                        <>
                                          {(data.LineItem3Type==="other_arch_changes" && data.other_arch_file_ref)?(
                                            <a href={data.other_arch_file_ref} target="_blank" className="ml-2">View Previous File</a>
                                          ):(
                                            <>
                                            {eval(`data.${data.LineItem3Type}_file_ref`) &&
                                              <a href={eval(`data.${data.LineItem3Type}_file_ref`)} target="_blank" className="ml-2">View Previous File</a>
                                            }
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                  <div className="input-group">
                                      <div className="custom-file">
                                         <input type="file" name="fileName3" className="custom-file-input" id={`${data.LineItem3Type}_file`} aria-describedby="inputGroupFileAddon04" onChange={this.handleFileChange} />
                                         <label className="custom-file-label">Choose file</label>
                                      </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </>
                        }
                        {data.currentRow >= 4 &&
                          <>
                            <div className="col-md-4 col-lg-3 col-xs-12">
                                <div className="form-group">
                                    <label>Type of Change</label>
                                    <input id="change_type4" className="form-select" row={4} value={data.LineItem4Type} onChange={this.handleLineItem} list="dl-change-types" />
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xs-12">
                              {data.LineItem4Type &&
                                <div className="form-group">
                                  <label> Description </label>
                                  <input type="text" name={data.LineItem4Type} className="form-control" maxLength="100" value={eval(`data.${data.LineItem4Type}`)} onChange={this.handleInputChange} />
                                </div>
                              }
                            </div>
                            <div className="col-md-2 col-lg-3 col-xs-12">
                              {data.LineItem4Type &&
                                <div className="form-group">
                                  <label>Attachment</label>
                                  {data.fileName4?(
                                    <>
                                      <span className="ml-1 text-success">{data.fileName4}</span>
                                    </>
                                  ):(
                                    <>
                                      {(data.LineItem4Type==="repainting" && data.repainting_color_ref)?(
                                        <a href={data.repainting_color_ref} target="_blank" className="ml-2">View Previous File</a>
                                      ):(
                                        <>
                                          {(data.LineItem4Type==="other_arch_changes" && data.other_arch_file_ref)?(
                                            <a href={data.other_arch_file_ref} target="_blank" className="ml-2">View Previous File</a>
                                          ):(
                                            <>
                                            {eval(`data.${data.LineItem4Type}_file_ref`) &&
                                              <a href={eval(`data.${data.LineItem4Type}_file_ref`)} target="_blank" className="ml-2">View Previous File</a>
                                            }
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                  <div className="input-group">
                                      <div className="custom-file">
                                         <input type="file" name="fileName4" className="custom-file-input" id={`${data.LineItem4Type}_file`} aria-describedby="inputGroupFileAddon04" onChange={this.handleFileChange} />
                                         <label className="custom-file-label">Choose file</label>
                                      </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </>
                        }
                        {data.currentRow >=5 &&
                          <>
                            <div className="col-md-4 col-lg-3 col-xs-12">
                                <div className="form-group">
                                    <label>Type of Change</label>
                                    <input id="change_type5" className="form-select" row={5} value={data.LineItem5Type} onChange={this.handleLineItem} list="dl-change-types" />
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xs-12">
                              {data.LineItem5Type &&
                                <div className="form-group">
                                  <label> Description </label>
                                  <input type="text" name={data.LineItem5Type} className="form-control" maxLength="100" value={eval(`data.${data.LineItem5Type}`)} onChange={this.handleInputChange} />
                                </div>
                              }
                            </div>
                            <div className="col-md-2 col-lg-3 col-xs-12">
                              {data.LineItem5Type &&
                                <div className="form-group">
                                  <label>Attachment</label>
                                  {data.fileName5?(
                                    <>
                                      <span className="ml-1 text-success">{data.fileName5}</span>
                                    </>
                                  ):(
                                    <>
                                      {(data.LineItem5Type==="repainting" && data.repainting_color_ref)?(
                                        <a href={data.repainting_color_ref} target="_blank" className="ml-2">View Previous File</a>
                                      ):(
                                        <>
                                          {(data.LineItem5Type==="other_arch_changes" && data.other_arch_file_ref)?(
                                            <a href={data.other_arch_file_ref} target="_blank" className="ml-2">View Previous File</a>
                                          ):(
                                            <>
                                            {eval(`data.${data.LineItem5Type}_file_ref`) &&
                                              <a href={eval(`data.${data.LineItem5Type}_file_ref`)} target="_blank" className="ml-2">View Previous File</a>
                                            }
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                  <div className="input-group">
                                      <div className="custom-file">
                                         <input type="file" name="fileName5" className="custom-file-input" id={`${data.LineItem5Type}_file`} aria-describedby="inputGroupFileAddon04" onChange={this.handleFileChange} />
                                         <label className="custom-file-label">Choose file</label>
                                      </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </>
                        }
                        {data.currentRow >=6 &&
                          <>
                            <div className="col-md-4 col-lg-3 col-xs-12">
                                <div className="form-group">
                                    <label>Type of Change</label>
                                    <input id="change_type6" className="form-select" row={6} value={data.LineItem6Type} onChange={this.handleLineItem} list="dl-change-types" />
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xs-12">
                              {data.LineItem6Type &&
                                <div className="form-group">
                                  <label> Description </label>
                                  <input type="text" name={data.LineItem6Type} className="form-control" maxLength="100" value={eval(`data.${data.LineItem6Type}`)} onChange={this.handleInputChange} />
                                </div>
                              }
                            </div>
                            <div className="col-md-2 col-lg-3 col-xs-12">
                              {data.LineItem6Type &&
                                <div className="form-group">
                                  <label>Attachment</label>
                                  {data.fileName6?(
                                    <>
                                      <span className="ml-1 text-success">{data.fileName6}</span>
                                    </>
                                  ):(
                                    <>
                                      {(data.LineItem6Type==="repainting" && data.repainting_color_ref)?(
                                        <a href={data.repainting_color_ref} target="_blank" className="ml-2">View Previous File</a>
                                      ):(
                                        <>
                                          {(data.LineItem6Type==="other_arch_changes" && data.other_arch_file_ref)?(
                                            <a href={data.other_arch_file_ref} target="_blank" className="ml-2">View Previous File</a>
                                          ):(
                                            <>
                                            {eval(`data.${data.LineItem6Type}_file_ref`) &&
                                              <a href={eval(`data.${data.LineItem6Type}_file_ref`)} target="_blank" className="ml-2">View Previous File</a>
                                            }
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                  <div className="input-group">
                                      <div className="custom-file">
                                         <input type="file" name="fileName6" className="custom-file-input" id={`${data.LineItem6Type}_file`} aria-describedby="inputGroupFileAddon04" onChange={this.handleFileChange} />
                                         <label className="custom-file-label">Choose file</label>
                                      </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </>
                        }
                        {data.currentRow >=7 &&
                          <>
                            <div className="col-md-4 col-lg-3 col-xs-12">
                                <div className="form-group">
                                    <label>Type of Change</label>
                                    <input id="change_type7" className="form-select" row={7} value={data.LineItem7Type} onChange={this.handleLineItem} list="dl-change-types" />
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xs-12">
                              {data.LineItem7Type &&
                                <div className="form-group">
                                  <label> Description </label>
                                  <input type="text" name={data.LineItem7Type} className="form-control" maxLength="100" value={eval(`data.${data.LineItem7Type}`)} onChange={this.handleInputChange} />
                                </div>
                              }
                            </div>
                            <div className="col-md-2 col-lg-3 col-xs-12">
                              {data.LineItem7Type &&
                                <div className="form-group">
                                  <label>Attachment</label>
                                  {data.fileName7?(
                                    <>
                                      <span className="ml-1 text-success">{data.fileName7}</span>
                                    </>
                                  ):(
                                    <>
                                    {(data.LineItem7Type==="repainting" && data.repainting_color_ref)?(
                                        <a href={data.repainting_color_ref} target="_blank" className="ml-2">View Previous File</a>
                                      ):(
                                        <>
                                          {(data.LineItem7Type==="other_arch_changes" && data.other_arch_file_ref)?(
                                            <a href={data.other_arch_file_ref} target="_blank" className="ml-2">View Previous File</a>
                                          ):(
                                            <>
                                            {eval(`data.${data.LineItem7Type}_file_ref`) &&
                                              <a href={eval(`data.${data.LineItem7Type}_file_ref`)} target="_blank" className="ml-2">View Previous File</a>
                                            }
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                  <div className="input-group">
                                      <div className="custom-file">
                                         <input type="file" name="fileName7" className="custom-file-input" id={`${data.LineItem7Type}_file`} aria-describedby="inputGroupFileAddon04" onChange={this.handleFileChange} />
                                         <label className="custom-file-label">Choose file</label>
                                      </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </>
                        }
                      </div>
                      <div className="text-right">
                        <button type="button" className="btn btn-primary" onClick={this.AddLineItem}><i className="fas fa-plus"></i></button>
                      </div>
                      <div className="form-group">
                          <input type="submit" id="asset-submit" className="btn btn-bg-success" value="Submit" />
                          {this.props.accRequestData?(
                            <Link to="/change-requests" className="btn btn-danger ml-3">Cancel</Link>
                          ):(
                            <button type="button" className="btn btn-danger ml-3" onClick={()=> this.props.setCurrentForm(null)} >Cancel</button>
                          )}
                      </div>
                  </fieldset>
                </form>
                <div className='bottomtitle'>
                  <p>These requests must be accompanied by a drawing showing size, shape, height, materials, color and
location. If the Committee considers color selection marginal, a request for a 4-5 ft area of the exterior to be
painted, so a better judgment can be made as to whether the selection will be in harmony with surrounding
colors.</p>
                </div>
                <div class="flex">
                  <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" />
                    <label for="vehicle1"> 
                    I understand that this request is submitted as prescribed by the Amended Declaration of Covenants, 
Conditions and Restrictions. I also understand that it is the homeowner’s responsibility to secure all 
necessary permits required by Hernando County. It is also understood that <b> CONTRACTORS ARE NOT 
PERMITTED TO ADVERTISE THEIR COMPANY NAME AND/OR ITS SERVICES AT THE JOB SITE.</b> 
                    </label>
                    </div>
                    <div className='rev'>
                <b>    <p>REV. 05/2019</p></b>
          
              </div>
            </div>
        </div>
      );
    }
}

class ConstructionForm extends Component {
    constructor(props) {
      super(props);
      this.state = {
        id                 :"",
        applicant_name     :"",
        applicant_address  :"",
        email              :"",
        phone              :"",
        change_state       :"",
        start_date         :moment().format("YYYY-MM-DD"),
        completion_date    :moment().format("YYYY-MM-DD"),
        HCBP_ref           :"",
        contractor_name    :"",
        contractor_address :"",
        contractor_license :"",
        contractor_type    :"general_contractor",
        properties         : [],
        isLoading          :true
      };
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSelect = this.handleSelect.bind(this);
      this.handleFileChange = this.handleFileChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSelect(event) {
      const target = event.target;
      const value =  target.value;
      var property = {};
      if(value){
        property = this.state.properties.find(a=>{
          if(a.id === parseInt(value)){
            return a;
          }
        });
        if(property.id){
          console.log("property", property);
          this.setState({applicant_name: property.first_name, 
                          applicant_address: property.wo_street_address,
                          email: property.email})
        }
      }
    }

    handleInputChange(event) {
      const target = event.target;
      const value =  target.value;
      const name = target.name;

      this.setState({
        [name]: value
      });
    }

    handleFileChange(event){
      this.setState({
        "filename": event.target.files[0].name
      })
    }

    handleSubmit(event) {
      event.preventDefault();
      const formEl = document.getElementById("construction-form");
      formEl.disabled = true;
      var formData = new FormData();
      var file = document.getElementById("HCBP_ref").files[0];
		  formData.append('File', file);
      var data = this.state;
      delete data.isLoading;

      formData.append('jsonData', JSON.stringify(data));
      postFile('/api/new-construction', formData)
        .then((response) => {
          console.log(response);
          this.props.navigate('/change-requests');
      });
    }

    async getResidentProperties() {
      try {
        const response = await fetch('/api/resident-properties');
        const json = await response.json();
        this.setState({ properties: json });
      } catch (error) {
        console.log(error);
      } finally {
        if(this.state.properties.length===1){
          var property = this.state.properties[0];
          this.setState({applicant_name: property.first_name, 
                applicant_address: property.wo_street_address,
                email: property.email, isLoading: false})
        }else{
          this.setState({ isLoading: false });
        }        
      }
    }

    componentDidMount() {
      if(this.props.accRequestData){
        var changeRequest = this.props.accRequestData;
        changeRequest.start_date = moment(changeRequest.start_date).format("YYYY-MM-DD");
        changeRequest.completion_date = moment(changeRequest.completion_date).format("YYYY-MM-DD");
        if(changeRequest) this.setState(changeRequest);
      }
      this.getResidentProperties();
    }

    render() {
      const data = this.state;
      const properties=this.state.properties.map(property=>
          <option key={property.id} value={property.id}>{property.wo_street_address}</option>
      );      
      return(
        <div className="card shadow mb-2">
            <div className="card-header py-3">
                <h4 className="m-0 font-weight-bold text-white">Construction Request Form</h4>
            </div>
            <div className="card-body">
             <div className='titles'>
                <p>
                WHISPERING OAKS ESTATES HOMEOWNERS ASSOCIATION INC. <br/>
ARCHITECTURAL CONTROL COMMITTEE <br/>
HOUSE PLAN REVIEW/ APPROVAL PROCESS
               
                </p>
                <h5>PROCEDURE FOR OBTAINING APPROVAL FOR NEW HOME CONSTRUCTION</h5>
              </div>
              <div className='content'>
                <ul>
                  <li>Homeowner or Developer must submit complete plans and specifications showing the nature, kind, shape, height, materials
and location of proposed house. The goal is to assure that new home design and construction will be consistent in external
design and location in relation to surrounding structures and topography, is harmonious with the neighborhood, architecturally
and artistically pleasing to existing homeowners, and will preserve property values.</li>
                  <li>Applicant must furnish a copy of a valid Hernando County Building Permit before commencement of construction.</li>
                  <li>APPLICANT WILLBE NOTIFIED IN WRITINGWHEN APPROVAL OR DENIAL PROCESS IS COMPLETED BY THE ACC.</li>
                  <li>ACC approval in writing is required before construction starts.</li>
              
                </ul>
                <h5>Plans must include:</h5>
                <ul>
                  <li>Site Plan /Lot Survey (including front, side, and rear setbacks)</li>
                  <li>Floorplan</li>
                  <li>Square footages (minimum 1700 sq. ft. A/C living area)</li>
                  <li> Elevations (front, rear and bothsides)</li>
                  <li>Type of construction</li>
                  <li> Type and color of roof</li>
                  <li>Exterior color selections (with color samples). Garage door must be the same color as main exterior.</li>
                  <li>Color of window frames, gutters and downspouts.</li>
                </ul>
                <h5>Additional Requirements:</h5>
                <ul>
                  <li>Lot must be graded in a manner that channels surface run-off water to conform with Whispering Oaks Estates Master
Drainage Plan. A copy of the Drainage Master Plan is on File in the Association's Office.</li>
                  <li>Concrete walkways and driveway</li>
                  <li>Automatic lawn sprinkler system. [Full lot irrigation system.]</li>
                  <li>Lawn sodded and lot landscapedin a manner acceptable to the Committee. ACC has no HOA requirements as to type of sod
and defers to Hernando County recommendations.</li>
                  <li>Sensor-controlled Post Light with all night operation— any solar light system must be rated DUSK TO DAWN — 6-8 hour
limitation would be insufficient. Color sample required if other than black. Option of additional side light for corner lots.</li>
                  <li>Pool specifications, if applicable. Pool/hot tub filter equipment must be enclosed or concealed by shrubs.</li>
                  <li>Copy of a Hernando County Building Permit Application</li>
                </ul>
                <h5>Other Information:</h5>
                <ul>
                  <li> Applicant mustagree tosupply a dumpster onsitefor trash and debrisorotherwise meet Hernando County Building or Code
Enforcement Department requirements to keep the area clean during construction period.</li>
                  <li> The ACC requires that any damage to Association streets and curbs, drainage inlets, sidewalks, street lights, street markers,
mailboxes, walls, etc., shall be repaired by the Homeowner. The Homeowner and/or its General Contractor/Builder shall
immediately report to the HOA ACC any spills of any damaging material while within the HOA community. Any such damage
must be cleaned up immediately. The Homeowner shall indemnify the Whispering Oaks Estates Homeowners Association
Inc. against all such damage, and agree to compensate the WOE HOA for any such losses.</li>
                  <li>ACC recommends construction hours between 6:00 a.m. to 6:00 p.m.</li>
                  <li> The main entrance off US 301 at Whispering Oaks Boulevard is the required entrance. [Country Club Drive is a public road
that ends at the Whispering Oaks G & C golf club property which is not a part of Whispering Oaks.]</li>
          
                </ul>
                <div className='constructionReq'>
                  <img src='/img/florida.jpg' />
                </div>
              </div>
              <form className="user acc-form" onSubmit={this.handleSubmit} autoComplete="off">
                <fieldset id="construction-form">
                  {this.state.properties.length>1 &&
                    <div className="row">
                      <div className="col-md-6 col-lg-4 col-xs-12">
                        <div className="form-group">
                          <label>Property</label>
                          <select name="property" className="form-control form-control-sm" onChange={this.handleSelect}>
                          <option value=""> -- Select Property -- </option>
                          {properties}
                          </select>
                        </div>
                      </div>     
                    </div>                
                  }
                    <div className="row">
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="form-group">
                                <label>Name of Owner</label>
                                <input type="text" name="applicant_name" className="form-control form-control-sm" maxLength="100" value={data.applicant_name} onChange={this.handleInputChange} required />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="form-group">
                                <label>Contact Email</label>
                                <input type="email" name="email" className="form-control form-control-sm" maxLength="100" value={data.email} onChange={this.handleInputChange} required />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="form-group">
                                <label>Contact Phone</label>
                                <input type="text" name="phone" className="form-control form-control-sm" maxLength="20" value={data.phone} onChange={this.handleInputChange} />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="form-group">
                                <label>Owner Address</label>
                                <textarea type="text" name="applicant_address" rows="1" maxLength="250" className="form-control form-control-sm" value={data.applicant_address} onChange={this.handleInputChange} required />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="form-group">
                                <label>General Contractor. Name</label>
                                <input type="text" name="contractor_name" className="form-control form-control-sm" maxLength="100" value={data.contractor_name} onChange={this.handleInputChange} required />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="form-group">
                                <label>General Contractor. Address</label>
                                <textarea type="text" name="contractor_address" rows="1" maxLength="250" className="form-control form-control-sm" value={data.contractor_address} onChange={this.handleInputChange} required />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="form-group">
                                <label>General Contractor. License</label>
                                <input type="text" name="contractor_license" className="form-control form-control-sm" maxLength="100" value={data.contractor_license} onChange={this.handleInputChange} required />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="form-group">
                                <label>Construction Incharge</label>
                                <select name="contractor_type" className="form-select form-select-sm" value={data.contractor_type} onChange={this.handleInputChange} >
                                   <option value="general_contractor">General Contractor</option>
                                   <option value="owner">Owner</option>
                                 </select>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xs-12">
                          <div className="form-group">
                            <label>Proposed start-up date is</label>
                            <input type="date" className="form-control form-control-sm" name="start_date"
                             value={data.start_date}
                             onChange={this.handleInputChange} required />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xs-12">
                          <div className="form-group">
                            <label>Proposed completion date is</label>
                            <input type="date" className="form-control form-control-sm" name="completion_date"
                             value={data.completion_date}
                             onChange={this.handleInputChange} required />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xs-12">
                            <div className="form-group">
                              <label>Copy of a Hernando County Building Permit Application Attach</label>
                              <div className="input-group">
                                  <div className="custom-file">
                                     <input type="file" className="custom-file-input" id="HCBP_ref" aria-describedby="inputGroupFileAddon04" onChange={this.handleFileChange} />
                                     <label className="custom-file-label" for="HCBP_ref">Choose file</label>
                                  </div>
                              </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xs-6">
                            <div className="form-group">
                              <input type="submit" id="asset-submit" className="btn btn-bg-success" value="Submit" />
                              {this.props.accRequestData?(
                                <Link to="/change-requests" className="btn btn-danger ml-3">Cancel</Link>
                              ):(
                                <button type="button" className="btn btn-danger ml-3" onClick={()=> this.props.setCurrentForm(null)} >Cancel</button>
                              )}
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-8 col-xs-6">
                            <div className="form-group">
                              {data.filename?(
                                <h6 className="text-success">{data.filename}</h6>
                              ):(
                                <>
                                  {data.hcbp_ref &&
                                    <a href={data.hcbp_ref} target="_blank"><small className="text-primary">{data.hcbp_ref}</small></a>
                                  }
                                </>
                              )}
                            </div>
                        </div>
                    </div>
                </fieldset>
              </form>
            </div>
        </div>
      );
    }
}

class TreeRemovalForm extends Component {
    constructor(props) {
      super(props);
      this.state = {
        id                  :"",
        applicant_name       :"",
        applicant_address    :"",
        email               :"",
        phone               :"",
        request_description :"",
        contractor_name     :"",
        contractor_license  :"",
        tree1Type           :"",
        tree1Diameter       :"",
        tree1Circumference  :"",
        tree1Location       :"",
        tree2Type           :"",
        tree2Diameter       :"",
        tree2Circumference  :"",
        tree2Location       :"",
        tree3Type           :"",
        tree3Diameter       :"",
        tree3Circumference  :"",
        tree3Location       :"",
        properties          :[],
        isLoading           :true,
      };
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSelect = this.handleSelect.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
      const target = event.target;
      const value =  target.value;
      const name = target.name;

      this.setState({
        [name]: value
      });
    }

    handleSubmit(event) {
      event.preventDefault();
      const formEl = document.getElementById("tree-removal-form");
      formEl.disabled = true;
      var data = this.state;
      delete data.isLoading;
      if(data.id){
        updateData('/api/tree-removal/'+data.id, data)
          .then((response) => {
            console.log(response);
            this.props.navigate('/change-requests');
        });
      }else{
        postData('/api/tree-removal', data)
          .then((response) => {
            console.log(response);
            this.props.navigate('/change-requests');
        });
      }
    }

    handleSelect(event) {
      const target = event.target;
      const value =  target.value;
      var property = {};
      if(value){
        property = this.state.properties.find(a=>{
          if(a.id === parseInt(value)){
            return a;
          }
        });
        if(property.id){
          console.log("property", property);
          this.setState({applicant_name: property.first_name, 
                          applicant_address: property.wo_street_address,
                          email: property.email})
        }
      }
    }

    async getResidentProperties() {
      try {
        const response = await fetch('/api/resident-properties');
        const json = await response.json();
        this.setState({ properties: json });
      } catch (error) {
        console.log(error);
      } finally {
        if(this.state.properties.length===1){
          var property = this.state.properties[0];
          this.setState({applicant_name: property.first_name, 
                applicant_address: property.wo_street_address,
                email: property.email, isLoading: false})
        }else{
          this.setState({ isLoading: false });
        }
      }
    }

    componentDidMount() {
      if(this.props.accRequestData){
          var changeRequest = this.props.accRequestData;
          this.setState(changeRequest);
      }
      this.getResidentProperties();
    }

    render() {
      const data = this.state;

      const properties=this.state.properties.map(property=>
          <option key={property.id} value={property.id}>{property.wo_street_address}</option>
      );

      return(
        <div className="card shadow mb-2">
            <div className="card-header py-3">
                <h4 className="m-0 font-weight-bold text-white">Tree Removal Request Form</h4>
            </div>
            <div className="card-body">
              <div className='titles'>
                <p>Whispering oaks estates homeowners association, inc.<br/>Architectural control committee<br/>
                35142 Whispering Oaks Boulevard, Ridge Manor FL 33523
                </p>
              </div>
              <form className="user acc-form" onSubmit={this.handleSubmit} autoComplete="off">
                <fieldset id="tree-removal-form">
                  {this.state.properties.length>1 &&
                  <div className="row">
                    <div className="col-md-6 col-lg-4 col-xs-12">
                      <div className="form-group">
                        <label>Property</label>
                        <select name="property" className="form-control form-control-sm" onChange={this.handleSelect}>
                        <option value=""> -- Select Property -- </option>
                        {properties}
                        </select>
                      </div>
                    </div>     
                  </div>           
                  }       
                  <div className="row">
                      <div className="col-md-6 col-lg-4 col-xs-12">
                          <div className="form-group">
                              <label>Name of Owner</label>
                              <input type="text" name="applicant_name" className="form-control form-control-sm" maxLength="100" value={data.applicant_name} onChange={this.handleInputChange} required />
                          </div>
                      </div>
                      <div className="col-md-6 col-lg-4 col-xs-12">
                          <div className="form-group">
                              <label>Address</label>
                              <textarea type="text" name="applicant_address" rows="1" maxLength="250" className="form-control form-control-sm" value={data.applicant_address} onChange={this.handleInputChange} required />
                          </div>
                      </div>
                      <div className="col-md-6 col-lg-4 col-xs-12">
                          <div className="form-group">
                              <label>Contact Email</label>
                              <input type="email" name="email" className="form-control form-control-sm" maxLength="100" value={data.email} onChange={this.handleInputChange} required />
                          </div>
                      </div>
                      <div className="col-md-6 col-lg-4 col-xs-12">
                          <div className="form-group">
                              <label>Contact Phone</label>
                              <input type="text" name="phone" className="form-control form-control-sm" maxLength="20" value={data.phone} onChange={this.handleInputChange} />
                          </div>
                      </div>
                      <div className="col-md-6 col-lg-4 col-xs-12">
                          <div className="form-group">
                              <label>Name of Licensed Contractor</label>
                              <input type="text" name="contractor_name" className="form-control form-control-sm" maxLength="100" value={data.contractor_name} onChange={this.handleInputChange} required />
                          </div>
                      </div>
                      <div className="col-md-6 col-lg-4 col-xs-12">
                          <div className="form-group">
                              <label>License</label>
                              <input type="text" name="contractor_license" className="form-control form-control-sm" maxLength="100" value={data.contractor_license} onChange={this.handleInputChange} required />
                          </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3 col-lg-3 col-xs-6">
                          <div className="form-group">
                              <label>Tree 1 Type</label>
                              <input type="text" name="tree1_type" className="form-control form-control-sm" maxLength="100" value={data.tree1_type} onChange={this.handleInputChange} />
                          </div>
                      </div>
                      <div className="col-md-3 col-lg-3 col-xs-6">
                          <div className="form-group">
                              <label>Diameter</label>
                              <input type="text" name="tree1_diameter" className="form-control form-control-sm" maxLength="100" value={data.tree1_diameter} onChange={this.handleInputChange} />
                          </div>
                      </div>
                      <div className="col-md-3 col-lg-3 col-xs-6">
                          <div className="form-group">
                              <label>Circumference</label>
                              <input type="text" name="tree1_circumference" className="form-control form-control-sm" maxLength="100" value={data.tree1_circumference} onChange={this.handleInputChange} />
                          </div>
                      </div>
                      <div className="col-md-3 col-lg-3 col-xs-6">
                          <div className="form-group">
                              <label>Location</label>
                              <input type="text" name="tree1_location" className="form-control form-control-sm" maxLength="100" value={data.tree1_location} onChange={this.handleInputChange} />
                          </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3 col-lg-3 col-xs-6">
                          <div className="form-group">
                              <label>Tree 2 Type</label>
                              <input type="text" name="tree2_type" className="form-control form-control-sm" maxLength="100" value={data.tree2_type} onChange={this.handleInputChange} />
                          </div>
                      </div>
                      <div className="col-md-3 col-lg-3 col-xs-6">
                          <div className="form-group">
                              <label>Diameter</label>
                              <input type="text" name="tree2_diameter" className="form-control form-control-sm" maxLength="100" value={data.tree2_diameter} onChange={this.handleInputChange} />
                          </div>
                      </div>
                      <div className="col-md-3 col-lg-3 col-xs-6">
                          <div className="form-group">
                              <label>Circumference</label>
                              <input type="text" name="tree2_circumference" className="form-control form-control-sm" maxLength="100" value={data.tree2_circumference} onChange={this.handleInputChange} />
                          </div>
                      </div>
                      <div className="col-md-3 col-lg-3 col-xs-6">
                          <div className="form-group">
                              <label>Location</label>
                              <input type="text" name="tree2_location" className="form-control form-control-sm" maxLength="100" value={data.tree2_location} onChange={this.handleInputChange} />
                          </div>
                      </div>
                   </div>
                    <div className="row">
                      <div className="col-md-3 col-lg-3 col-xs-6">
                          <div className="form-group">
                              <label>Tree 3 Type</label>
                              <input type="text" name="tree3_type" className="form-control form-control-sm" maxLength="100" value={data.tree3_type} onChange={this.handleInputChange} />
                          </div>
                      </div>
                      <div className="col-md-3 col-lg-3 col-xs-6">
                          <div className="form-group">
                              <label>Diameter</label>
                              <input type="text" name="tree3_diameter" className="form-control form-control-sm" maxLength="100" value={data.tree3_diameter} onChange={this.handleInputChange} />
                          </div>
                      </div>
                      <div className="col-md-3 col-lg-3 col-xs-6">
                          <div className="form-group">
                              <label>Circumference</label>
                              <input type="text" name="tree3_circumference" className="form-control form-control-sm" maxLength="100" value={data.tree3_circumference} onChange={this.handleInputChange} />
                          </div>
                      </div>
                      <div className="col-md-3 col-lg-3 col-xs-6">
                          <div className="form-group">
                              <label>Location</label>
                              <input type="text" name="tree3_location" className="form-control form-control-sm" maxLength="100" value={data.tree3_location} onChange={this.handleInputChange} />
                          </div>
                      </div>
                   </div>
                    <div className="row">
                      <div className="col-md-12 col-xs-12">
                          <div className="form-group">
                              <label>Reason for request</label>
                              <textarea type="text" name="request_description" rows="1" maxLength="500" className="form-control form-control-sm" value={data.request_description} onChange={this.handleInputChange} required />
                          </div>
                      </div>
                      <div className="col-md-10 col-xs-12">
                          <div className="form-group">
                            <input type="submit" id="asset-submit" className="btn btn-bg-success" value="Submit" />
                            {this.props.accRequestData?(
                              <Link to="/change-requests" className="btn btn-danger ml-3">Cancel</Link>
                            ):(
                              <button type="button" className="btn btn-danger ml-3" onClick={()=> this.props.setCurrentForm(null)} >Cancel</button>
                            )}
                          </div>
                      </div>
                    </div>
                  </fieldset>
              </form>
              <div className='flex'>
              <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
  <label for="vehicle1"> *Under Florida law, "permit ...for pruning, trimming, or removal of a tree on residential property
shall not be reguired <b>if the property' owner obtains documentation from an arborist certified
by the International Society of Arboriculture or a Florida licensed landscape architect that the
tree presents a danger to persons or property."</b>  Our WOE covenants state: “…No trees shall be
cut off of any Lot unless the cutting of the trees is necessary for the construction of a
residence or addition thereto, recognizing, however, the right of owners to remove dead,
dying, diseased or dangerous trees and to do appropriate pruning or maintenance thereof."</label>
              </div>
              <div className='rev'>
                <b>    <p>REV. 07/2022</p></b>
          
              </div>
           
            </div>
        </div>
      );
    }
}

class ComplaintViolationForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      applicant_name: "",
      applicant_address: "",
      email: "",
      phone: "",
      isLoading: true,
      properties: [],
      nature_of_complaint: "",
      complaint_location: "",
      complaint_datetime: "",
      complaint_comments: "",
      showModal: false,
      isToastVisible: false,
      isCheckboxChecked : false,      
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleConfirmSubmit = this.handleConfirmSubmit.bind(this);
    this.formatDateTimeLocal = this.formatDateTimeLocal.bind(this);
    this.generatePDF = this.generatePDF.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  formatDateTimeLocal(isoString) {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  async getResidentProperties() {
    try {
      const response = await fetch("/api/resident-properties");
      const json = await response.json();
      this.setState({ properties: json });
    } catch (error) {
      console.log(error);
    } finally {
      if (this.state.properties.length === 1) {
        var property = this.state.properties[0];
        this.setState({
          applicant_name: property.first_name,
          applicant_address: property.wo_street_address,
          email: property.email,
          phone: property.phone,
          isLoading: false,
        });
      } else {
        this.setState({ isLoading: false });
      }
    }
  }

  componentDidMount() {
    if (this.props) {
      var changeRequest = this.props.accRequestData;
      this.setState(changeRequest);
    }
    this.getResidentProperties();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.accRequestData !== this.props.accRequestData &&
      this.props.accRequestData
    ) {
      this.setState({
        ...this.props.accRequestData,
        complaint_datetime: this.formatDateTimeLocal(
          this.props.accRequestData.complaint_datetime
        ),
      });
    }
  }

  toggleModal() {
    this.setState({ showModal: !this.state.showModal });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.toggleModal();
  }

  handleCheckboxChange = () => {
      this.setState({isCheckboxChecked : !this.state.isCheckboxChecked});
  };

  showToast = () => {
    this.setState({ isToastVisible: true });
    setTimeout(() => {
      this.setState({ isToastVisible: false, showModal:false });
      this.props.navigate("/change-requests");
    }, 5000); // Toast disappears after 5 seconds
  };

  handleConfirmSubmit(event){
    event.preventDefault();
    if (this.state.isCheckboxChecked) {
      // Proceed with the backend request and download PDF logic
      const formEl = document.getElementById("complaint-violation-form");
      formEl.disabled = true;
      var data = this.state;
      delete data.isLoading;
      console.log("Data",data);
      if(data.id){
        updateData('/api/complaint-violation/'+data.id, data)
          .then((response) => {
            console.log(response);
            this.generatePDF();
            //this.props.navigate('/change-requests');
        });
      }else{
        postData('/api/complaint-violation', data)
          .then((response) => {
            console.log(response);
            this.generatePDF();
            //this.props.navigate('/change-requests');
        });
      }
  } else {
      alert("Please confirm by checking the checkbox.");
  }
    this.toggleModal();
    this.showToast();
  }

  generatePDF() {
    const doc = new jsPDF();
    // Add a green header background
    doc.setFillColor(0, 128, 0);
    doc.rect(0, 0, 210, 15, 'F'); // Full-width rectangle for the header
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(14);
    doc.text("Complaint Violation Request Form", 105, 10, { align: "center" });
  
    // Reset text color for body content
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(12);
  
    // Add organization details
    doc.text("Whispering Oaks Estates Homeowners Association, Inc.", 105, 25, { align: "center" });
    doc.text("Architectural Control Committee", 105, 33, { align: "center" });
    doc.text("35142 Whispering Oaks Boulevard, Ridge Manor FL 33523", 105, 41, { align: "center" });
    doc.setFont("bold");
    doc.text("COMPLAINT - REPORT OF VIOLATION - INQUIRY", 105, 49, { align: "center" });
    doc.setFont("normal");
  
    // Add a bordered box for the content
    doc.rect(10, 55, 190, 110); // x, y, width, height
  
    // Add form content with labels and values
    doc.text("Name of Owner:", 12, 65);
    doc.text(this.state.applicant_name || "N/A", 70, 65);
  
    doc.text("Address:", 12, 75);
    doc.text(this.state.applicant_address || "N/A", 70, 75);
  
    doc.text("Contact Email:", 12, 85);
    doc.text(this.state.email || "N/A", 70, 85);
  
    doc.text("Nature of the Complaint:", 12, 95);
    doc.text(this.state.nature_of_complaint || "N/A", 70, 95);
  
    doc.text("Location where it occurred:", 12, 105);
    doc.text(this.state.complaint_location || "N/A", 70, 105);
  
    doc.text("Date and Time:", 12, 115);
    doc.text(this.state.complaint_datetime!==""?moment(this.state.complaint_datetime).format('DD/MM/YYYY hh:mm A') : "N/A", 70, 115);
  
    doc.text("Comments:", 12, 125);
    const comments = doc.splitTextToSize(this.state.complaint_comments || "N/A", 120);
    doc.text(comments, 70, 125);
  
    // Save the PDF
    doc.save("Complaint_Violation_Form.pdf");
  
    // Optional: Close the modal or reset the form after generating the PDF
  }
  
  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  }

  handleCancel(){
    this.setState({
      nature_of_complaint: "",
      complaint_location: "",
      complaint_datetime: "",
      complaint_comments: "",
    })
  }

  render() {
    const data = this.state;

    return (
      <div className="card shadow mb-2">
        <div className="card-header py-3">
          <h4 className="m-0 font-weight-bold text-white">
            Complaint Violation Request Form
          </h4>
        </div>
        <div className="card-body">
          <div className="titles">
            <p>
              Whispering Oaks Estates Homeowners Association, Inc.<br />
              Architectural Control Committee<br />
              35142 Whispering Oaks Boulevard, Ridge Manor FL 33523
            </p>
            <h5>COMPLAINT - REPORT OF VIOLATION - INQUIRY</h5>
          </div>
          <form
            className="complaint-violation-form"
            onSubmit={this.handleSubmit}
            autoComplete="off"
          >
            <fieldset id="complaint-violation-form">
              <div className="row">
                <div className="col-md-6 col-lg-4 col-xs-12">
                  <div className="form-group">
                    <label>Name of Owner</label>
                    <input
                      type="text"
                      name="applicant_name"
                      className="form-control form-control-sm"
                      maxLength="100"
                      value={data.applicant_name}
                      onChange={this.handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xs-12">
                  <div className="form-group">
                    <label>Address</label>
                    <textarea
                      type="text"
                      name="applicant_address"
                      rows="1"
                      maxLength="250"
                      className="form-control form-control-sm"
                      value={data.applicant_address}
                      onChange={this.handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xs-12">
                  <div className="form-group">
                    <label>Contact Email</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control form-control-sm"
                      maxLength="100"
                      value={data.email}
                      onChange={this.handleInputChange}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group">
                  <label>Nature of the Complaint</label>
                  <input
                    required
                    type="text"
                    name="nature_of_complaint"
                    className="form-control form-control-sm"
                    maxLength="100"
                    value={data.nature_of_complaint}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-lg-6 col-xs-12">
                  <div className="form-group">
                    <label>Location where the incident occurred</label>
                    <input
                      required
                      type="text"
                      name="complaint_location"
                      className="form-control form-control-sm"
                      maxLength="100"
                      value={data.complaint_location}
                      onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-md-12 col-lg-6 col-xs-12">
                  <div className="form-group">
                    <label>Date and Time</label>
                    <input
                      type="text"
                      name="complaint_datetime"
                      placeholder="dd-mm-yyyy hh:mm"
                      className="form-control form-control-sm"
                      value={data.complaint_datetime}
                      onFocus={(e) => {
                        e.target.type = 'datetime-local';
                        setTimeout(() => e.target.showPicker(), 0); // Programmatically trigger the picker
                      }}
                      onBlur={(e) => {
                        if (!e.target.value) e.target.type = 'text';
                      }}
                      onChange={this.handleInputChange}
                    />

                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group">
                  <label>Comments</label>
                  <textarea
                    required
                    name="complaint_comments"
                    className="form-control form-control-sm"
                    value={data.complaint_comments}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>
              <div className="row"> 
                <div className="col-md-12 ">
                  <div className="form-group p-3 rounded"  style={{backgroundColor : "#fefcbf", color : '#f59e0b'}}>
                    <p className="mb-0">Note :</p>
                    <p className="pl-5 mt-0">After the form has been submitted, the Complaint Violation Request Form will be downloaded. </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="d-flex justify-content-start form-group text-center gap-2">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                    <button className="btn btn-danger" onClick={this.handleCancel}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>

        {this.state.showModal && (
          <div
            className="modal fade show d-block"
            role="dialog"
            style={{
              backdropFilter: 'blur(5px)',
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
            }}
          >
            <div
              className="modal-dialog modal-dialog-centered"
              role="document"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                maxWidth: '900px', // Adjusted width for responsiveness
                width: '95%',
              }}
            >
              <div
                className="modal-content"
                style={{
                  borderRadius: '10px',
                  overflow: 'hidden',
                  backgroundColor: '#f9f9f9',
                  color: '#333',
                  width: '100%',
                  maxHeight: '90vh', // Height for scrollable content
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {/* Modal Header */}
                <div
                  className="modal-header"
                  style={{
                    backgroundColor: '#eaeaea',
                    color: '#333',
                    padding: '15px 20px',
                    fontSize: '18px',
                  }}
                >
                  <h5 className="modal-title">Confirm Submission</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={this.toggleModal}
                    style={{
                      color: 'red',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      border: 'none',
                      background: 'transparent',
                    }}
                  >
                    <span>&times;</span>
                  </button>
                </div>

                {/* Modal Body - Scrollable */}
                <div
                  className="modal-body"
                  style={{
                    padding: '20px',
                    overflowY: 'auto',
                    flex: '1',
                  }}
                >
                  <h4 style={{ fontWeight: 'bold', marginBottom: '20px', textAlign: 'center' }}>
                    Please confirm the details before submitting:
                  </h4>

                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                      gap: '15px',
                    }}
                  >
                    {[
                      { label: 'Name of Owner', value: data.applicant_name },
                      { label: 'Address', value: data.applicant_address },
                      { label: 'Contact Email', value: data.email },
                      { label: 'Contact Phone', value: data.phone },
                      { label: 'Nature of Complaint', value: data.nature_of_complaint },
                      { label: 'Location', value: data.complaint_location },
                      {
                        label: 'Date and Time',
                        value:
                          data.complaint_datetime !== ''
                            ? moment(data.complaint_datetime).format('DD/MM/YYYY hh:mm A')
                            : 'NIL',
                      },
                      { label: 'Comments', value: data.complaint_comments },
                    ].map((item, index) => (
                      <div
                        key={index}
                        style={{
                          padding: '10px',
                          borderRadius: '8px',
                          backgroundColor: '#eaeaea',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                          fontSize: '16px',
                          wordBreak: 'break-word',
                          display: 'flex',
                          width: '100%',
                          justifyContent: 'space-between',
                          gridColumn: ['Nature of Complaint', 'Comments'].includes(item.label) ? '1 / -1' : 'auto',
                        }}
                      >
                        <span>{item.label}:</span>
                        <strong>{item.value}</strong>
                      </div>
                    ))}
                  </div>

                  {/* Checkbox Section */}
                  <div style={{ marginTop: '20px' }}>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="confirmationCheckbox"
                        checked={this.state.isCheckboxChecked}
                        onChange={this.handleCheckboxChange}
                      />
                      <label className="form-check-label" htmlFor="confirmationCheckbox">
                        I agree to submit the hard copy of Complaint form which will be downloaded to the Activity Center or mail it to them.
                      </label>
                    </div>
                    <p style={{ marginTop: '10px', fontSize: '14px', color: '#555' }}>
                      Note: The submission is mandatory as part of the process.
                    </p>
                  </div>
                </div>

                {/* Modal Footer */}
                <div
                  className="modal-footer"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '15px 20px',
                    backgroundColor: '#eaeaea',
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={this.toggleModal}
                    style={{
                      borderRadius: '5px',
                      padding: '10px 20px',
                      color: 'white',
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className={`btn btn-primary ${
                      this.state.isCheckboxChecked ? '' : 'disabled'
                    }`}
                    disabled={!this.state.isCheckboxChecked}
                    onClick={this.handleConfirmSubmit}
                    style={{
                      borderRadius: '5px',
                      padding: '10px 20px',
                      backgroundColor: '#28a745',
                      color: '#fff',
                      border: 'none',
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.isToastVisible && (
          <div
            style={{
              position: 'fixed',
              bottom: '20px',
              left: '50%',
              transform: 'translateX(-50%)',
              backgroundColor: '#28a745', // Green background
              color: '#fff',
              padding: '15px 20px',
              borderRadius: '8px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              fontSize: '17px',
              zIndex: 1050,
              textAlign:'center'
            }}
          >
            Thank you for submitting the form. Your response will be taken into account.
            You are requested to submit the physical copy to the provided address or email the downloaded soft copy to the HOA
          </div>
        )}

      </div>
    );
  }
}

export default ComplaintViolationForm;


function AccForms() {
  let navigate = useNavigate();
  const [currentForm, setCurrentForm] = useState(null);
  const [isDownload, setIsDownload] = useState(false);

  const handleDownloadWithPopup = (acc_name) => {
      // Show a popup
      // Trigger the download programmatically
      const link = document.createElement("a");
      if(acc_name==="architecture_change"){
        link.href = architecture_change; // URL of the file
        link.download = "Architecture_Change.pdf"; // Desired file name
      }
      else if(acc_name==="new_construction"){
        link.href = new_construction; // URL of the file
        link.download = "New_Construction.pdf"; // Desired file name

      }
      else if(acc_name==="tree_removal"){
        link.href = tree_removal; // URL of the file
        link.download = "Tree_Removal.pdf"; // Desired file name

      }
      else if(acc_name==="complaint_violation"){
        link.href = complaint_violation; // URL of the file
        link.download = "Complaint_Violation.pdf"; // Desired file name

      }
      else{
        link.href = estate_sale; // URL of the file
        link.download = "Estate_Sale.pdf"; // Desired file name
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setIsDownload(true);
  };

  return (
    <>
      <div id="wrapper">
          <SideNav />
          <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                  <TopBar />
                  <div className="container-fluid">
                      <datalist id="dl-change-types"></datalist>
                      {currentForm==="Architecture"?(
                        <>
                          <ArchitectureChangeForm navigate={navigate} setCurrentForm={setCurrentForm} />
                        </>
                      ):currentForm==="New Construction"?(
                        <>
                          <ConstructionForm navigate={navigate} setCurrentForm={setCurrentForm} />
                        </>
                      ):currentForm==="Tree Removal"?(
                        <>
                          <TreeRemovalForm navigate={navigate} setCurrentForm={setCurrentForm} />
                        </>
                      ):currentForm==="Complaint Violation"?(
                        <>
                          <ComplaintViolationForm navigate={navigate} setCurrentForm={setCurrentForm} />
                        </>
                      ):(
                        <>
                          {/*
                          <div className="mt-4 pt-5">
                            <div className="d-flex justify-content-center align-items-center">
                              
                              <div className="col-md-3 mb-3">
                                <div className="card shadow-sm">
                                  <div className="card-body acc-link text-center" onClick={()=>setCurrentForm("Architecture")}>
                                    <img className="acc-form-images" src="/img/architecture.jpg" width="200" alt="architecture" />
                                    <h5 className="mt-2 mb-0 fw-bold"> Architecture Change Request</h5>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-3 mb-3">
                                <div className="card shadow-sm">
                                  <div className="card-body acc-link text-center" onClick={()=>setCurrentForm("New Construction")}>
                                    <img className="acc-form-images" src="/img/construction.jpg" width="200" alt="new_construction" />
                                    <h5 className="mt-2 mb-0 fw-bold"> New Construction Request</h5>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-3 mb-3">
                                <div className="card shadow-sm">
                                  <div className="card-body acc-link text-center" onClick={()=>setCurrentForm("Tree Removal")}>
                                    <img className="acc-form-images" src="/img/tree_removal.jpg" width="200" alt="tree_removal" />
                                    <h5 className="mt-2 mb-0 fw-bold"> Tree Removal Request</h5>
                                  </div>
                                </div>
                              </div>

                              {/* Fourth Card **}
                              <div className="col-md-3 mb-3">
                                  <div className="card shadow-sm">
                                    <div className="card-body acc-link text-center" onClick={() => setCurrentForm("Complaint Violation")}>
                                      <img className="acc-form-images" src="/img/tree_removal.jpg" width="200" alt="complaint_violation" />
                                      <h5 className="mt-2 mb-0 fw-bold"> Complaint Violation Request</h5>
                                    </div>
                                  </div>
                                </div>
                            </div>
                          </div>
                          */}
                        <div className="mt-4 pt-5">
                            <div className="container">
                              {/*<div className="container">
                                <p style={{fontWeight:'bold', color : 'red'}}>    
                                  ** All forms must be download and submitted at Activity Center, 35142 Whispering Oaks Blvd, Ridge Manor, FL 33523 **
                                </p>
                              </div>*/}
                              <div className="row g-3 justify-content-center">
                                {/* First Row: 3 Cards */}
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                  <a
                                    href={architecture_change}
                                    download
                                    style={{ textDecoration: "none", color: "inherit" }}
                                    onClick={(e) => {
                                      e.preventDefault(); // Prevent immediate navigation or download
                                      handleDownloadWithPopup("architecture_change");
                                    }}
                                  >
                                    <div className="card shadow-sm">
                                      <div className="card-body acc-link text-center" style={{ paddingBottom : "15px" }}>
                                        <img
                                          className="acc-form-images img-fluid"
                                          src="/img/architecture.jpg"
                                          alt="architecture"
                                          style={{ margin: "0 auto", width: "200px", maxHeight:"200px" , objectFit:'cover'}}
                                        />
                                        <h5 className="mt-2 mb-0 fw-bold">Architecture Change Request</h5>
                                      </div>
                                    </div>
                                  </a>
                                </div>

                                <div className="col-lg-4 col-md-6 col-sm-12">
                                  <a
                                    href={new_construction}
                                    download
                                    style={{ textDecoration: "none", color: "inherit" }}
                                    onClick={(e) => {
                                      e.preventDefault(); // Prevent immediate navigation or download
                                      handleDownloadWithPopup("new_construction");
                                    }}
                                  >
                                    <div className="card shadow-sm">
                                      <div className="card-body acc-link text-center">
                                        <img
                                          className="acc-form-images img-fluid"
                                          src="/img/construction.jpg"
                                          alt="new_construction"
                                          style={{ margin: "0 auto", width: "200px", maxHeight:"200px" , objectFit:'contain'}}
                                        />
                                        <h5 className="mt-2 mb-0 fw-bold">New Construction Request</h5>
                                      </div>
                                    </div>
                                  </a>
                                </div>

                                <div className="col-lg-4 col-md-6 col-sm-12">
                                  <a
                                    href={tree_removal}
                                    download
                                    style={{ textDecoration: "none", color: "inherit" }}
                                    onClick={(e) => {
                                      e.preventDefault(); // Prevent immediate navigation or download
                                      handleDownloadWithPopup("tree_removal");
                                    }}
                                  >
                                    <div className="card shadow-sm">
                                      <div className="card-body acc-link text-center">
                                        <img
                                          className="acc-form-images img-fluid"
                                          src="/img/tree_removal.jpg"
                                          alt="tree_removal"
                                          style={{ margin: "0 auto", width: "200px", maxHeight:"200px" , objectFit:'contain'}}
                                        />
                                        <h5 className="mt-2 mb-0 fw-bold">Tree Removal Request</h5>
                                      </div>
                                    </div>
                                  </a>
                                </div>

                                {/* Second Row: 2 Cards */}
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                  <a
                                    href={complaint_violation}
                                    download
                                    style={{ textDecoration: "none", color: "inherit" }}
                                    onClick={(e) => {
                                      e.preventDefault(); // Prevent immediate navigation or download
                                      handleDownloadWithPopup("complaint_violation");
                                    }}
                                  >
                                    <div className="card shadow-sm">
                                      <div className="card-body acc-link text-center" style={{padding : "13px"}}>
                                        <img
                                          className="acc-form-images img-fluid"
                                          src="/img/complaint_violation_request.jpg"
                                          alt="complaint_violation"
                                          style={{ margin: "0 auto", width: "200px", maxHeight:"190px" , objectFit:'contain'}}
                                        />
                                        <h5 className="mt-2 mb-0 fw-bold">Complaint Violation Request</h5>
                                      </div>
                                    </div>
                                  </a>
                                </div>

                                <div className="col-lg-4 col-md-6 col-sm-12">
                                  <a
                                    href={estate_sale}
                                    download
                                    style={{ textDecoration: "none", color: "inherit" }}
                                    onClick={(e) => {
                                      e.preventDefault(); // Prevent immediate navigation or download
                                      handleDownloadWithPopup("estate_sale");
                                    }}
                                  >
                                    <div className="card shadow-sm">
                                      <div className="card-body acc-link text-center">
                                        <img
                                          className="acc-form-images img-fluid"
                                          src="/img/estate_sale_pic.jpg"
                                          alt="estate_sale"
                                          style={{ margin: "0 auto",}}
                                        />
                                        <h5 className="mt-2 mb-0 fw-bold">Estate Sale Request</h5>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>

                          {isDownload && (
                            <div
                              style={{
                                position: 'fixed',
                                bottom: '50%',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                backgroundColor: '#28a745', // Green background
                                color: '#fff',
                                borderRadius: '8px',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                fontSize: '17px',
                                zIndex: 1050,
                                textAlign:'center'
                              }}
                            >
                             <div
                              style={{
                                position: 'relative',
                                padding: '30px',
                                borderRadius: '8px',
                                opacity : 0.9,
                                backgroundColor: 'rgb(197, 195, 191)', // Soft yellow background for note
                                color: '#7c3aed', // Dark purple text color
                                border: '1px solid black', // Border for better visibility
                                fontFamily: 'Arial, sans-serif',
                                fontSize: '14px',
                              }}
                            >
                              <button
                                type="button"
                                className="rounded"
                                style={{
                                  position: 'absolute',
                                  top: '0px',
                                  right: '0px',
                                  backgroundColor: 'red', // Red background for the button
                                  color: 'white', // White color for the "X" icon
                                  border: 'none',
                                  //borderRadius: '50%',
                                  width: '24px',
                                  height: '24px',
                                  fontSize: '18px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  cursor: 'pointer',
                                }}
                                onClick={() => setIsDownload(false)}
                              >
                                &#10005; {/* Unicode for cross (X) */}
                              </button>
                              <p style={{ margin: 0, fontSize: 16, color:'black' }}>
                                All forms must be download and submitted at Activity Center, 35142 Whispering Oaks Blvd, Ridge Manor, FL 33523
                              </p>
                            </div>

                            </div>
                          )}


                        </>
                      )}
                  </div>
              </div>
              <Footer />
          </div>
      </div>
      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>
      <LogoutModal />
    </>
  );
}

function EditAccRequest() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [accRequest, setAccRequest] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [currentForm, setCurrentForm] = useState(null);

  const getAccRequestDetails = async() => {
    try {
      const response = await fetch('/api/change-request/'+id);
      const json = await response.json();
      console.log("Received ACC Form",json);
      setAccRequest(json.acc_request);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(()=>{
    getAccRequestDetails();
  },[])

  return (
    <>
      <div id="wrapper">
          <SideNav />
          <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                  <TopBar />
                  <div className="container-fluid">
                      <datalist id="dl-change-types"></datalist>
                      {accRequest.change_state==="Architecture"?(
                        <>
                          <ArchitectureChangeForm navigate={navigate} setCurrentForm={setCurrentForm} accRequestData={accRequest} />
                        </>
                      ):accRequest.change_state==="New Construction"?(
                        <>
                          <ConstructionForm navigate={navigate} setCurrentForm={setCurrentForm} accRequestData={accRequest} />
                        </>
                      ):accRequest.change_state==="Tree Removal" ? (                        <>
                          <TreeRemovalForm navigate={navigate} setCurrentForm={setCurrentForm} accRequestData={accRequest} />
                        </>
                      ):
                      <>
                        <ComplaintViolationForm navigate={navigate} setCurrentForm={setCurrentForm} accRequestData={accRequest} />
                      </>
                      }
                  </div>
              </div>
              <Footer />
          </div>
      </div>
      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>
      <LogoutModal />
    </>
  );
}

class AccRequestResponseForm extends Component {
    constructor(props) {
      super(props);
      this.state = {
        acc_request_id :this.props.accRequestId,
        response_text  :"",
        filename       :null
      };
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
      const target = event.target;
      const value =  target.value;
      const name = target.name;
      this.setState({
        [name]: value
      });
    }

    handleSubmit(event) {
      event.preventDefault();
      var CRform = document.getElementById("acc-request-response-form");
      CRform.disabled=true;
      var formData = new FormData();
      var file = document.getElementById("inputGroupFile05").files[0];
      if(file){
        this.setState({"filename": file.name});
        formData.append('File', file);
      }
      var data = this.state;
      formData.append('jsonData', JSON.stringify(data));

      postFile('/api/acc_request_response', formData)
        .then((response) => {
          console.log(response);
          CRform.disabled=false;
          this.setState({"filename": null, 'response_text': ''});
          document.getElementById("response-form").reset();
          this.props.getAccRequestDetails();
      });
    }


    render() {
      return(
          <form className="user mt-2" id="response-form" onSubmit={this.handleSubmit} autoComplete="off">
            <fieldset id="acc-request-response-form">
              <small className="fw-bold">Comment </small>
              <div className="row">
                  <div className="col-lg-12 col-xs-12">
                      <div className="input-group">
                        <input type="text" name="response_text" maxLength="250" value={this.state.response_text} onChange={this.handleInputChange} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" required />
                        <div className="input-group-append">
                          <label for="inputGroupFile05" className="btn btn-outline-secondary mb-0 input-group-button"><i className="fas fa-file action-buttons"></i></label>
                          <input id="inputGroupFile05" type="file" className="response-file-input" onChange={this.handleSubmit} />
                          <button type="submit" className="btn btn-outline-primary input-group-button"><i className="fas fa-comment-alt action-buttons"></i></button>
                        </div>
                      </div>
                  </div>
              </div>
            </fieldset>
          </form>
      );
    }
}

const AccRequestDetails = (props) => {
    var data = props.data;
    const acc_request_responses = props.responses.map((item,index)=>{
      return(
        <div key={item.id} className="row no-gutters my-1">
          <div className={item.commented_admin?"col-12 d-flex justify-content-end text-primary":"col-12 text-dark"}>
          {item.response_text && item.response_text}
          {item.file_url && <embed src={item.file_url} width="300" height="300" />  }
          </div>
          <div className={item.commented_admin?"col-12 d-flex justify-content-end":"col-12"}>
            <small className="mx-2">{item.commented_user},</small>
            <small className="m-0">{moment(item.created_date).format("lll")}</small>
          </div>
        </div>
      );
    });

    return (
      <>
        <div className="row">
            <div className="col-xs-12 col-md-6 col-lg-7">
              <div className="card shadow-sm mb-4">
                <div className="card-header py-3 d-flex align-items-center">
                    <h4 className="m-0 font-weight-bold text-light">ACC Request Details</h4>
                </div>
                <div className="card-body acc-approval-form">
                  <div className="row">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Date of Application </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {moment(data.application_date).format("LLL")} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Application Status </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.status} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Name of the Owner </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.applicant_name} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Address </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.applicant_address} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Contact Email </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.email} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Contact Phone </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.phone} </div>
                  </div>
                  {(data.status==="Approved") &&
                    (
                      <>
                        <div className="row my-3">
                          <div className="col-xs-6 col-md-4 font-weight-bold">Approved Date </div>
                          <div className="col-xs-6 col-md-8 font-weight-bold"> {moment(data.approved_date).format("LLL")} </div>
                        </div>
                        <div className="row my-3">
                          <div className="col-xs-6 col-md-4 font-weight-bold">Chairperson ACC </div>
                          <div className="col-xs-6 col-md-8 font-weight-bold"> {data.chairpersonACC} </div>
                        </div>
                      </>
                    )
                  }
                  {(data.status==="declined") &&
                    (
                      <>
                        <div className="row my-3">
                          <div className="col-xs-6 col-md-4 font-weight-bold">Not Approved Date </div>
                          <div className="col-xs-6 col-md-8 font-weight-bold"> {moment(data.declined_date).format("LLL")} </div>
                        </div>
                        <div className="row my-3">
                          <div className="col-xs-6 col-md-4 font-weight-bold">Chairperson ACC </div>
                          <div className="col-xs-6 col-md-8 font-weight-bold"> {data.chairpersonACC} </div>
                        </div>
                      </>
                    )
                  }
                  {data.change_state==="Architecture"?(
                    <>
                      {
                        data.roof_replacement &&
                         (
                           <>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Roof Replacement </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.roof_replacement} </div>
                              </div>
                              {data.roof_replacement_file_ref &&
                                <div className="row my-3">
                                  <div className="col-xs-6 col-md-4 font-weight-bold">Roof Replacement file </div>
                                  <div className="col-xs-6 col-md-8">
                                    <a href={data.roof_replacement_file_ref} className="hyperlink font-weight-bold" target="_blank">View attachment</a>
                                  </div>
                                </div>
                              }
                            </>
                          )
                        }
                      {
                        data.repainting &&
                        (
                          <>
                            <div className="row my-3">
                              <div className="col-xs-6 col-md-4 font-weight-bold">Repainting </div>
                              <div className="col-xs-6 col-md-8 font-weight-bold"> {data.repainting} </div>
                            </div>
                            {data.repainting_color_ref &&
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Repainting color sample </div>
                                <div className="col-xs-6 col-md-8">
                                  <a href={data.repainting_color_ref} className="hyperlink font-weight-bold" target="_blank">View attachment</a>
                                </div>
                              </div>
                            }
                          </>
                        )
                      }
                      {
                        data.patio &&
                        (
                          <>
                            <div className="row my-3">
                              <div className="col-xs-6 col-md-4 font-weight-bold">Patio </div>
                              <div className="col-xs-6 col-md-8 font-weight-bold"> {data.patio} </div>
                            </div>
                            {data.patio_file_ref &&
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Patio file </div>
                                <div className="col-xs-6 col-md-8">
                                  <a href={data.patio_file_ref} className="hyperlink font-weight-bold" target="_blank">View attachment</a>
                                </div>
                              </div>
                            }
                          </>
                        )
                      }
                      {
                        data.garage_door &&
                        (
                          <>
                            <div className="row my-3">
                              <div className="col-xs-6 col-md-4 font-weight-bold">Garage Door </div>
                              <div className="col-xs-6 col-md-8 font-weight-bold"> {data.garage_door} </div>
                            </div>
                            {data.garage_door_file_ref &&
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Garage door file </div>
                                <div className="col-xs-6 col-md-8">
                                  <a href={data.garage_door_file_ref} className="hyperlink font-weight-bold" target="_blank">View attachment</a>
                                </div>
                              </div>
                            }
                          </>
                        )
                      }
                      {
                        data.cart_room_door &&
                        (
                          <>
                            <div className="row my-3">
                              <div className="col-xs-6 col-md-4 font-weight-bold">Cart Room Door </div>
                              <div className="col-xs-6 col-md-8 font-weight-bold"> {data.cart_room_door} </div>
                            </div>
                            {data.cart_room_door_file_ref &&
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Cart room door file </div>
                                <div className="col-xs-6 col-md-8">
                                  <a href={data.cart_room_door_file_ref} className="hyperlink font-weight-bold" target="_blank">View attachment</a>
                                </div>
                              </div>
                            }
                          </>
                        )
                      }
                      {
                        data.other_arch_changes &&
                        (
                          <>
                            <div className="row my-3">
                              <div className="col-xs-6 col-md-4 font-weight-bold">Other Arch changes </div>
                              <div className="col-xs-6 col-md-8 font-weight-bold"> {data.other_arch_changes} </div>
                            </div>
                            {data.other_arch_file_ref &&
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Other Arch changes file </div>
                                <div className="col-xs-6 col-md-8">
                                  <a href={data.other_arch_file_ref} className="hyperlink font-weight-bold" target="_blank">View attachment</a>
                                </div>
                              </div>
                            }
                          </>
                        )
                      }
                    </>
                  ):(
                    <>
                      {data.change_state==="New Construction"?(
                        <>
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Construction Incharge / Handled By </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {data.contractor_type} </div>
                          </div>
                          {(data.contractor_type==="contractor") &&
                            <>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">General Contractor. Name </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.contractor_name} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">General Contractor. Address </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.contractor_address} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">General Contractor. License </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.contractor_license} </div>
                              </div>
                            </>
                          }
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Proposed start-up date </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {moment(data.start_date).format("LL")} </div>
                          </div>
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Proposed completion date </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {moment(data.completion_date).format("LL")} </div>
                          </div>
                          {data.hcbp_ref &&
                            <div className="row my-3">
                              <h5 className="col-xs-12 col-md-12 font-weight-bold">Copy of a Hernando County Building Permit Application Attachment:</h5>
                              <a href={data.hcbp_ref} className="hyperlink font-weight-bold" target="_blank">View attachment</a>
                            </div>
                          }
                        </>
                      ):(
                        <>
                        { data.change_state==="New Construction"?(
                        <>
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Reason for Request </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {data.reason} </div>
                          </div>
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Name of the Licensed Contractor </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {data.contractor_name} </div>
                          </div>
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Contractor License </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {data.contractor_license} </div>
                          </div>
                          {data.tree1_type &&
                            <>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 1 Type </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree1_type} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 1 Diameter </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree1_diameter} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 1 Circumference </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree1_circumference} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 1 Location </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree1_location} </div>
                              </div>
                            </>
                          }
                          {data.tree2_type &&
                            <>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 2 Type </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree2_type} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 2 Diameter </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree2_diameter} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 2 Circumference </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree2_circumference} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 2 Location </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree2_location} </div>
                              </div>
                            </>
                          }
                          {data.tree3_type &&
                            <>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 3 Type </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree3_type} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 3 Diameter </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree3_diameter} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 3 Circumference </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree3_circumference} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 3 Location </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree3_location} </div>
                              </div>
                            </>
                          }
                        </>
                        ):(
                          <>
                            <div className="row my-3">
                              <div className="col-xs-6 col-md-4 font-weight-bold">Nature of the Complaint </div>
                              <div className="col-xs-6 col-md-8 font-weight-bold"> {data.nature_of_complaint} </div>
                            </div>
                            <div className="row my-3">
                              <div className="col-xs-6 col-md-4 font-weight-bold">Complaint Location </div>
                              <div className="col-xs-6 col-md-8 font-weight-bold"> {data.complaint_location} </div>
                            </div>
                            <div className="row my-3">
                              <div className="col-xs-6 col-md-4 font-weight-bold">Complaint Date and Time </div>
                              <div className="col-xs-6 col-md-8 font-weight-bold"> {data.complaint_datetime !== ''? moment(data.complaint_datetime).format('DD/MM/YYYY hh:mm A'): 'NIL'} </div>
                            </div>
                            <div className="row my-3">
                              <div className="col-xs-6 col-md-4 font-weight-bold">Comments </div>
                              <div className="col-xs-6 col-md-8 font-weight-bold"> {data.complaint_comments} </div>
                            </div>
                          </>
                      )}
                    </>
                  )}
                  </>
                  )}
                  
                  <Link to="/change-requests" className="btn btn-danger float-right">Close</Link>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-md-6 col-lg-5">
            <div className="card shadow mb-2">
              <div className="card-header">
                  <h4 className="m-0 font-weight-bold text-light">Responses</h4>
              </div>
              <div className="card-body">
                <div className="acc-request-response-view">
                  {acc_request_responses}
                </div>
                <AccRequestResponseForm accRequestId={data.id} getAccRequestDetails={props.getAccRequestDetails} />
              </div>
            </div>
            </div>
        </div>
      </>
    );
}

function ViewAccRequest() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [accRequestData, setAccRequestData] = useState({});
  const [responses, setResponses] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const getAccRequestDetails = async() => {
    try {
      const response = await fetch('/api/change-request/'+id);
      const json = await response.json();
      setAccRequestData(json.acc_request);
      setResponses(json.acc_request_responses);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(()=>{
    getAccRequestDetails();
  }, []);

  return(
    <>
      <div id="wrapper">
          <SideNav />
          <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                  <TopBar />
                  <div className="container-fluid">
                    {!isLoading?
                      <AccRequestDetails data={accRequestData} responses={responses} getAccRequestDetails={getAccRequestDetails} navigate={navigate} />
                    :
                      <> </>
                    }
                  </div>
              </div>
              <Footer />
          </div>
      </div>
      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>
      <LogoutModal />
    </>
  );
}

export { ChangeRequests, AccForms, EditAccRequest, ViewAccRequest };
